module.exports = __webpack_public_path__ + "static/media/Nic Carey.752f8f7e.png";